export default "__VITE_ASSET__01df21a5__"